import React from 'react';
import {Container} from 'react-bootstrap';

interface AppContainerProps {
    children: React.ReactNode;
}

export const AppContainer = React.memo(({children}: AppContainerProps) => (
    <Container fluid>
        {children}
    </Container>
));
